// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"ef3f4d5e","238":"24a14d41","626":"e87174c5","999":"fac32e08"}[chunkId] + ".chunk.js";
};